import { render, staticRenderFns } from "./Table_fixed.vue?vue&type=template&id=4419ff80&scoped=true"
import script from "./Table_fixed.vue?vue&type=script&lang=js"
export * from "./Table_fixed.vue?vue&type=script&lang=js"
import style0 from "./Table_fixed.vue?vue&type=style&index=0&id=4419ff80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4419ff80",
  null
  
)

export default component.exports